import React from 'react';
import PropTypes from 'prop-types';

const UserIcon = props => {
  const size = props.size || 50;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      className={props.className || ''}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.9996 0C11.1929 0 0 11.1932 0 24.9999C0 38.8063 11.1929 50.0003 24.9996 50.0003C38.8063 50.0003 50 38.8063 50 24.9999C50 11.1929 38.8063 0 24.9996 0ZM25.0758 36.7944L24.9231 36.7941H14.2442C14.2442 28.9846 21.103 28.9865 22.625 26.9444L22.7992 26.0133C20.6608 24.9296 19.1513 22.3169 19.1513 19.2612C19.1513 15.2354 21.77 11.9714 24.9996 11.9714C28.2291 11.9714 30.8478 15.2354 30.8478 19.2612C30.8478 22.2909 29.3652 24.8872 27.2553 25.9881L27.4536 27.0463C29.1235 28.9893 35.7541 29.116 35.7541 36.7944H25.0758Z"
        fillOpacity={1}
      />
    </svg>
  );
};

UserIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default UserIcon;
